import { d as i, a7 as a, a6 as g, P as l } from "./address-CmQhtpW5.mjs";
const B = (t) => {
  const e = t.decode.bind(t), o = t.encode.bind(t);
  return { decode: e, encode: o };
};
var d = {};
Object.defineProperty(d, "__esModule", { value: !0 });
function x(t) {
  {
    const e = i.Buffer.from(t);
    e.reverse();
    const o = e.toString("hex");
    return o.length === 0 ? BigInt(0) : BigInt(`0x${o}`);
  }
}
var I = d.toBigIntLE = x;
function E(t) {
  {
    const e = t.toString("hex");
    return e.length === 0 ? BigInt(0) : BigInt(`0x${e}`);
  }
}
d.toBigIntBE = E;
function L(t, e) {
  {
    const o = t.toString(16), u = i.Buffer.from(o.padStart(e * 2, "0").slice(0, e * 2), "hex");
    return u.reverse(), u;
  }
}
var p = d.toBufferLE = L;
function h(t, e) {
  {
    const o = t.toString(16);
    return i.Buffer.from(o.padStart(e * 2, "0").slice(0, e * 2), "hex");
  }
}
d.toBufferBE = h;
const m = (t) => (e) => {
  const o = a(t, e), { encode: u, decode: s } = B(o), n = o;
  return n.decode = (r, c) => {
    const f = s(r, c);
    return I(i.Buffer.from(f));
  }, n.encode = (r, c, f) => {
    const b = p(r, t);
    return u(b, c, f);
  }, n;
}, y = m(8), S = (t) => {
  const e = g(t), { encode: o, decode: u } = B(e), s = e;
  return s.decode = (n, r) => !!u(n, r), s.encode = (n, r, c) => {
    const f = Number(n);
    return o(f, r, c);
  }, s;
}, _ = (t) => {
  const e = a(32, t), { encode: o, decode: u } = B(e), s = e;
  return s.decode = (n, r) => {
    const c = u(n, r);
    return new l(c);
  }, s.encode = (n, r, c) => {
    const f = n.toBuffer();
    return o(f, r, c);
  }, s;
};
export {
  S as b,
  _ as p,
  y as u
};
